import React, { useState } from "react";
import styles from "./Dropdown.module.scss";
import { Link } from 'react-router-dom';
const Dropdown = ({ data,name,handleNavigation,route }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  return (
    <li
      className={styles.navItem}
      onMouseEnter={toggleDropdown}
      onMouseLeave={toggleDropdown}
      onClick={()=>{handleNavigation(route)}}
    >
      <div className={styles.navLink}>
        {name} <i className="fas fa-chevron-down"></i>
      </div>

      {/* Dropdown Menu */}
      {isDropdownOpen && (
        <div className={styles.dropdown}>
          {data.map((column, index) => (
            <div key={index} className={styles.dropdownColumn}>
              <div className={styles.columnTitle}>{column[0]}</div>
              <ul className={styles.columnItems}>
                {column.slice(1).map((item, itemIndex) => (
                  <li key={itemIndex} className={styles.columnItem}>
                    <Link to={`/solutions/${item.replaceAll('/','-')}`}
                     onClick={(e) => {
                      e.stopPropagation(); // Stop the event from propagating to parent elements
                      handleNavigation(`/solutions/${item.replaceAll('/', '-')}`);
                      toggleDropdown();
                    }}
                    >{item}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      )}
    </li>
  );
};

export default Dropdown;
